import React, { useState } from "react";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { ChangePassword as ChangePasswordPost } from "../../services/account-setting.services";
import { SWAL_SETTINGS } from "../../../../utils/Constants";
import { handleServerValidations, globalLoader } from "../../../../utils/commonfunction";

export default function ChangePassword() {
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const eyeStyle = {
    position: "absolute",
    right: "24px",
    top: "37%",
    transform: "translateY(50%)",
    cursor: "pointer",
    fontSize: "18px",
  };

  const validationSchema = Yup.object({
    current_password: Yup.string().required("Current password is required"),
    new_password: Yup.string()
      .min(5, "Password must be at least 5 characters long")
      .matches(/^[A-Z]/, "Password must start with an uppercase letter")
      .matches(/[!@#$%^&*(),.?":{}|<>]/, "Password must contain at least one special character")
      .required("New password is required"),
    confirm_new_password: Yup.string()
      .oneOf([Yup.ref("new_password"), null], "Passwords do not match")
      .required("Confirm password is required"),
  });

  return (
    <div className="main-content">
      <div className="customer-part">
        <div className="card-box">
          <div className="with-change-pas">
            <h3 className="h3-headline mb-5">Change Password</h3>

            <Formik
              initialValues={{
                current_password: "",
                new_password: "",
                confirm_new_password: "",
              }}
              validationSchema={validationSchema}
              onSubmit={async (values, { resetForm }) => {
                globalLoader(true);
                setSubmitted(true);
                try {
                  const response = await ChangePasswordPost(values);
                  if (response?.success) {
                    Swal.fire({
                      icon: "success",
                      text: response.message,
                      ...SWAL_SETTINGS,
                    });
                    resetForm();
                  } else {
                    Swal.fire({
                      icon: "error",
                      html: handleServerValidations(response),
                      ...SWAL_SETTINGS,
                    });
                  }
                } catch (error) {
                  console.log("error ====>", error);
                } finally {
                  globalLoader(false);
                  setSubmitted(false);
                }
              }}
            >
              {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <div className="row g-3 text-start">
                    {/* Current Password */}
                    <div className="form-group col-md-12" style={{ position: "relative" }}>
                      <label className="form-label subtitle-1">Current Password</label>
                      <input
                        type={showCurrent ? "text" : "password"}
                        name="current_password"
                        value={values.current_password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="form-control"
                        placeholder="Enter current password"
                      />
                      <i
                        className={!showCurrent ? "ri-eye-off-line" : "ri-eye-line"}
                        style={eyeStyle}
                        onClick={() => setShowCurrent((prev) => !prev)}
                      />
                      <span className="text-danger">
                        {errors.current_password && touched.current_password && errors.current_password}
                      </span>
                    </div>

                    {/* New Password */}
                    <div className="form-group col-md-12" style={{ position: "relative" }}>
                      <label className="form-label subtitle-1">New Password</label>
                      <input
                        type={showNew ? "text" : "password"}
                        name="new_password"
                        value={values.new_password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="form-control"
                        placeholder="Enter new password"
                      />
                      <i
                        className={!showNew ? "ri-eye-off-line" : "ri-eye-line"}
                        style={eyeStyle}
                        onClick={() => setShowNew((prev) => !prev)}
                      />
                      <span className="text-danger">
                        {errors.new_password && touched.new_password && errors.new_password}
                      </span>
                    </div>

                    {/* Confirm New Password */}
                    <div className="form-group col-md-12" style={{ position: "relative" }}>
                      <label className="form-label subtitle-1">Confirm New Password</label>
                      <input
                        type={showConfirm ? "text" : "password"}
                        name="confirm_new_password"
                        value={values.confirm_new_password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="form-control"
                        placeholder="Enter confirm new password"
                      />
                      <i
                        className={!showConfirm ? "ri-eye-off-line" : "ri-eye-line"}
                        style={eyeStyle}
                        onClick={() => setShowConfirm((prev) => !prev)}
                      />
                      <span className="text-danger">
                        {errors.confirm_new_password &&
                          touched.confirm_new_password &&
                          errors.confirm_new_password}
                      </span>
                    </div>

                    <div className="text-center mt-5">
                      <button
                        type="submit"
                        className="btn btn-oring px-5"
                        disabled={submitted}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}
